import { cn } from "@/lib/utils";

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("skeleton h-4 w-full", className)} {...props} />;
}

export function SkeletonCard() {
  return (
    <div className="surface rounded-2xl p-5">
      <Skeleton className="h-3 w-24 mb-4" />
      <Skeleton className="h-8 w-32 mb-3" />
      <Skeleton className="h-2 w-full" />
    </div>
  );
}

export function SkeletonChart() {
  return (
    <div className="surface rounded-2xl p-5">
      <Skeleton className="h-3 w-32 mb-6" />
      <div className="flex items-end gap-3 h-48">
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={i}
            className="skeleton flex-1 rounded-md"
            style={{ height: `${30 + ((i * 17) % 65)}%` }}
          />
        ))}
      </div>
    </div>
  );
}

export function SkeletonRow({ cols = 5 }: { cols?: number }) {
  return (
    <div className="grid gap-4 px-4 py-3" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
      {Array.from({ length: cols }).map((_, i) => (
        <Skeleton key={i} className="h-3" />
      ))}
    </div>
  );
}
